<div class="content">
  <div class="alert" *ngFor="let alert of alerts">
    <div class="alert-content">
      <div class="alert-avatar"[style.background-color]="getColorFromName(alert.name)">{{alert.name.substring(0,1)}}</div>
      <div class="alert-text">
        <div class="alert-name">{{alert.name}}</div>
        <div class="alert-desc"><span *ngIf="alert.compasses && alert.compasses.length > 0">{{getCompassesString(alert)}}: </span>{{alert.text}} </div>
      </div>
    </div>
    <div class="action-buttons">
      <button  (click)="onEdit(alert)" mat-icon-button >
        <mat-icon>edit_outline</mat-icon>
      </button>
      <button  (click)="onDelete(alert)" mat-icon-button >
        <mat-icon>delete_outline</mat-icon>
      </button>
    </div>
  </div>
  <div class="add-new-container">
    <button mat-fab color="primary" (click)="onEdit(null)">
   + Add new
    </button>
  </div>
</div>

